// extracted by mini-css-extract-plugin
export default {"stepContainer":"MdtOnboardingStepper_stepContainer__QR171","labelContainer":"MdtOnboardingStepper_labelContainer__jlbDg"};